export default __webpack_public_path__ + "static/LpRpo01PageProblemImage-1c7a02a6bb1b51ccbf06abd5a20349b1.png";